import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthBridgeAuthenticate } from './models/auth-bridge-authenticate.model';
import { AuthBridgeAuthenticateResult } from './models/auth-bridge-authenticate-result.model';

@Injectable({
    providedIn: 'root'
})

export class AuthBridgeSuccessService {

    private base = environment.apiTMAuthBridge;

    private httpOptions = {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': '*'
          })
      };
    
      constructor(protected http: HttpClient) { }

      public async AuthenticateBridge(entity: AuthBridgeAuthenticate) : Promise<AuthBridgeAuthenticateResult> {
        try {
          
          let apiUrl = `${this.base}/User/Authenticate`

          const body = JSON.stringify(entity);
          var result = await this.http.post<AuthBridgeAuthenticateResult>(apiUrl, body, this.httpOptions).toPromise();
          return result;

        } catch (e) {      
          return null;
        }
      }
}